import { ELanguageStatus, EUserLevel, TAuthUser } from '../store/general/types';
import { setAuthUserAction, setLibraryGroupIdAction } from '../store/general/actions';
import { updateUserLanguages } from './updateUserLanguages';
import { updateUserGroups } from './updateUserGroups';
import { EventsRouter } from '../../common/events/eventsRouter';
import { Events } from '../../common/events/types';
import { getDispatch, getState } from '../store';
import { TLanguageCode } from '../store/models/types';
import { getGeneralStorage } from '../../common/utils/local-storage/local-storage-helpers';
import { getUserStateStorage } from '../../common/utils/local-storage/user-state';
import { getOneTimeTooltipsStorage } from '../../common/utils/local-storage/onetime-tooltips';
import { getUserGroups } from '../store/models/selectors';
import { LanguageRest } from '../../common/rest/userLanguage/languageRest';
import { AuthUserEffects } from './authUserEffects';
import { IUserRestResponse } from '../../common/rest/user/userRest';
import { restoreAppSettings, restoreUserSettings } from './prepareAfterOpen';

export class LoginUserEffects {

  public static async prepareBeforeShowSelectLangs(result: IUserRestResponse) {
    const dispatch = getDispatch();
    dispatch(setAuthUserAction(result.authUser));
    await Promise.all([
      dispatch(updateUserLanguages()),
      dispatch(updateUserGroups(true)),
    ]);
    restoreAppSettings(result.appSettings);
    restoreUserSettings(result.settings);

    try {
      EventsRouter.setUser(result.authUser);
      EventsRouter.trackEvent(Events.INSTALL, new Date(), {
        userId: result.authUser.hashId
      });
    } catch(e) {
      console.error(e);
    }

  }

  public static async prepareLangsOnInstall(nativeLangCode: TLanguageCode, targetLangCode: TLanguageCode, landingName: string, createGroup: boolean, level?: EUserLevel): Promise<number> {
    let resultGroupId: number = 0;
    const dispatch = getDispatch();
    await LanguageRest.updateUserLanguages([
      { code: nativeLangCode, status: ELanguageStatus.KNOW },
      { code: targetLangCode, status: ELanguageStatus.TO_LEARN }
    ]);
    if (level) {
      await AuthUserEffects.updateUser({level});
    }
    // const ONBOARDING_LANG = 'zh'; // LNG-951 add chineese to onboarding
    // if (nativeLangCode !== ONBOARDING_LANG) {
    //   await UserTranslateLangEffects.addLang(ONBOARDING_LANG);
    // }

    getGeneralStorage().updateData({
      showTelegramBotPopup: true,
      showVideoPromptsTutorial: true,
      flashPhraseDetails: true,
    });

    getUserStateStorage().clearAll();
    getOneTimeTooltipsStorage().saveData({
      showPhrasesEdit: true,
      showNativeLanguage: true,
      showNativeAvailable: true,
      showTutorialPopup: true,
      showTutorial: true,
      showSaveForMagic: true,
      showSavedForMagic: false,
      showTranslations: true,
      showFullscreen: true,
      showSelectionTip: true,
    });
    try {
      await dispatch(updateUserLanguages());
    } catch (e) {
      console.error(e);
    }
    LoginUserEffects.storeDefaultVideo();
    return resultGroupId;
  }

  private static storeDefaultVideo() {
    const dispatch = getDispatch();
    const groups = getUserGroups(getState());
    if (groups && groups.length) {
      dispatch(setLibraryGroupIdAction(groups[0].id));
    }
  }

}
